import React from "react";
import FieldForm from "./FieldForm";
import {
    BusinessPortalHeader, PortalPageShell
} from "src/components";
import { FormDataProvider } from "./FormDataContext";

const QuotesForm = ({ companyUuid, user, setQuotes, settingsPreview, manageQuotes, quote }) => {
    const params = { companyUuid, user, setQuotes };
    return (
        // Main Conainter of Add My quotes 
        <FormDataProvider quote={quote}>
            <PortalPageShell height="calc(100vh - 64px - 1rem)" overflow="hidden" paddingBottom="0">
                <BusinessPortalHeader
                    title={`${quote?.uuid ? "Edit" : "Add"} Your Custom Quote`}
                    description="Add your own motivational quotes by uploading a background image, adding quote text, selecting custom fonts, adjusting colours and sizes, and even attaching an optional article for deeper inspiration. Your custom quote will appear beautifully in your Me Business app."
                    maxWidth="94.5rem"
                />
                <FieldForm
                    params={params}
                    manageQuotes={manageQuotes}
                    quote={quote}
                    settingsPreview={settingsPreview}
                />
            </PortalPageShell>
        </FormDataProvider>
    );
};

export default QuotesForm;
